import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ArrayUtil from '../../../../../../utils/ArrayUtil';
import ImportedFileList from './ImportedFileList';

class FileList extends Component {
  render() {
    const { importedFiles, loading } = this.props;
    const fileList = ArrayUtil.isNotEmpty(importedFiles)
      ? ArrayUtil.reservedSortByProp(importedFiles, 'createdOn')
      : [];
    return <ImportedFileList files={fileList} loading={loading} />;
  }
}

FileList.propTypes = {
  importedFiles: PropTypes.arrayOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default FileList;
